import { extractTextFromTipTap } from "../../../../../src/shared/schemas/CharacterSchema";

export function orderedScenesBySectionAndScene(obj) {
  // Convert the input object to an array of items
  let items = Object.entries(obj);

  // Sort the items by section and scene
  items.sort((a, b) => {
    // items are in the form [id, { section, scene, id, ... }]
    a = a[1];
    b = b[1];

    // First, compare sections
    if (a.section !== b.section) {
      return a.section - b.section;
    }

    // if sections are equal, compare scenes
    if (a.scene !== b.scene) {
      return a.scene - b.scene;
    }

    // if scenes are equal, sort id vals in alphabetical order
    // this will match ordering in Firestore to ensure stable ordering
    return a.id.localeCompare(b.id);
  });

  return items;
}

/**
 * Converts a single character to plain text representation
 * Replicates server-side Character.promptRepresentation() logic
 */
export function characterToPlainText(character) {
  const lines = [];

  // Add default fields (matching server-side keys order)
  const name = extractTextFromTipTap(character.name);
  if (name) lines.push(`NAME: ${name}`);

  if (character.roles) lines.push(`ROLES: ${character.roles}`);

  const pronouns = extractTextFromTipTap(character.pronouns);
  if (pronouns) lines.push(`PRONOUNS: ${pronouns}`);

  const groups = extractTextFromTipTap(character.groups);
  if (groups) lines.push(`GROUPS: ${groups}`);

  const otherNames = extractTextFromTipTap(character.otherNames);
  if (otherNames) lines.push(`OTHER NAMES: ${otherNames}`);

  // Add custom fields
  if (character.customFields && Array.isArray(character.customFields)) {
    character.customFields.forEach((field) => {
      const text = extractTextFromTipTap(field.value);
      if (text && field.label) {
        lines.push(`${field.label.toUpperCase()}: ${text}`);
      }
    });
  }

  return lines.join("\n");
}

/**
 * Converts a single worldbuilding entry to plain text representation
 * Replicates server-side WorldbuildingEntry.promptRepresentation() logic
 */
export function worldbuildingEntryToPlainText(entry) {
  const lines = [];

  // Add default fields (matching server-side keys order)
  const name = extractTextFromTipTap(entry.name);
  if (name) lines.push(`NAME: ${name}`);

  if (entry.role) lines.push(`ROLE: ${entry.role}`);

  const otherNames = extractTextFromTipTap(entry.otherNames);
  if (otherNames) lines.push(`OTHER NAMES: ${otherNames}`);

  // Add custom fields
  if (entry.customFields && Array.isArray(entry.customFields)) {
    entry.customFields.forEach((field) => {
      const text = extractTextFromTipTap(field.value);
      if (text && field.label) {
        lines.push(`${field.label.toUpperCase()}: ${text}`);
      }
    });
  }

  return lines.join("\n");
}
